export default __webpack_public_path__ + "static/media/ask-us-anything.b2666e8b.png";